module.exports = __webpack_public_path__ + "media/images/icons/outlined/environment-49048e8a24f535b81ea7c605ef09e2a4.svg";